var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtiva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-139"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.86,
    y: 75.65,
    width: 73.32,
    height: 121.23,
    transform: "translate(195.04 272.54) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.4,
    y: 75.65,
    width: 1.45,
    height: 121.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.29,
    y: 80.99,
    width: 58.45,
    height: 110.56,
    transform: "translate(195.04 272.54) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.49,
    y: 118.22,
    width: 73.32,
    height: 121.23,
    transform: "translate(376.29 357.66) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.03,
    y: 118.22,
    width: 1.45,
    height: 121.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.92,
    y: 123.55,
    width: 58.45,
    height: 110.56,
    transform: "translate(376.29 357.66) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2,351.07c1.82-33-3-86-8.21-104.39-.69-2.43-1.47-5.25-2.66-5.62h0c-3.4-1.08-4.93,4.25-4.51,6.09,2,8.86,3.87,30.85,5.7,69.1.91,19,0,32.08,2.44,34.83Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.78,277.52c4.78-15.45,66-31.32,48.35-14.7-4.39,4.14-24.83,15.05-33.22,26.52-6.52,8.91-13.11,23.9-14.85,32.21C98.3,304.07,95.6,287.82,98.78,277.52Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.75,297.11c10.66-23.51,44.75-27.73,35.59-15.32-3.6,4.87-16.8,10.43-25.2,21.9-6.52,8.91-13.11,23.89-14.84,32.21C100.53,318.41,101.3,306.93,105.75,297.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.35,295.11c-12.62-30.24-58.21-32.65-46.08-18.6,4.61,5.35,20.72,15.14,32.89,27.76,9.46,9.8,20.12,26,23.75,35C100.56,320.72,97.44,307.31,92.35,295.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.65,261.27c11.3-20.71,45.5-22.93,35.73-11.6-3.83,4.46-16.29,10.11-24.43,21.24-6.33,8.64-13.93,19.92-15.62,28C92.59,281.93,92.64,270.46,97.65,261.27Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.81,261.68C78.9,248.8,39,234.64,49.36,246.3c10.91,12.23,18.66,10.13,29,20.81,8,8.3,17,22.06,20.1,29.6C96.45,281,94.19,270.88,87.81,261.68Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4,246.85c5.66-10.18,29-17.67,22.91-9.86-4.25,5.42-9.35,9.14-14.76,16.52-4.19,5.74-9.89,12.95-11,18.3C95.05,260.56,95,252.92,98.4,246.85Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.19,249.93C83.49,243.61,53,228.61,60,238.24c2.73,3.79,14.36,13,22.19,21.14,6.09,6.3,12.77,11.44,15.1,17.17C95.75,264.64,94.9,256.24,89.19,249.93Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,272.11c-8.33-9.22-69.06-21.1-53.45-10.92,5.34,3.48,28.82,9.46,40.27,21.33,8.89,9.21,12.09,24.49,15.5,32.86C108.3,300.67,105.34,281.34,97,272.11Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6,349.73l.78,27.59c.08,5.24,1.3,5.08,2.78,5.08h19.63c1.47,0,2.69.16,2.78-5.08l.78-27.59c.09-5.68-1.18-10.47-2.78-10.47H89.38C87.78,339.26,86.51,344.05,86.6,349.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43,344.29h29.09a.8.8,0,0,0,.83-.63l.69-5.28a.76.76,0,0,0-.83-.79H84.73a.77.77,0,0,0-.83.79l.69,5.28A.81.81,0,0,0,85.43,344.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.85,
    y: 227.56,
    width: 22.02,
    height: 148.16,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.08,
    y: 375.72,
    width: 166.92,
    height: 6.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.87,
    y: 227.56,
    width: 153.36,
    height: 148.16,
    transform: "translate(735.1 603.28) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.08,
    y: 221.73,
    width: 22.51,
    height: 5.83,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.59,
    y: 221.73,
    width: 158.41,
    height: 5.83,
    transform: "translate(735.59 449.29) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.2,297.51H298.9V239.9H436.2Zm-136-1.26H434.94V241.16H300.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.2,363.38H298.9V306.57H436.2Zm-136-1.26H434.94V307.83H300.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.28,251.23H340.82a2.38,2.38,0,0,1-2.37-2.37h0a2.38,2.38,0,0,1,2.37-2.37h53.46a2.38,2.38,0,0,1,2.37,2.37h0A2.38,2.38,0,0,1,394.28,251.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.45,
    y: 313.16,
    width: 58.21,
    height: 4.74,
    rx: 2.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.41 221.67 424.01 221.67 429.17 164.96 365.57 164.96 360.41 221.67",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.25 221.67 421.85 221.67 427.01 164.96 363.41 164.96 358.25 221.67",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.14 215.39 420.16 171.24 369.12 171.24 365.1 215.39 416.14 215.39",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.68 180.26 341.91 221.67 372.39 221.67 376.16 180.26 345.68 180.26",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.1 180.26 340.33 221.67 370.81 221.67 374.58 180.26 344.1 180.26",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.27 184.84 345.33 217.09 366.65 217.09 369.58 184.84 348.27 184.84",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-139"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-139",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble--inject-139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.32,113.72a18.6,18.6,0,0,0-24.83-10.18c-8.52,3.76-13.14,14.69-9.93,23.42a18.51,18.51,0,0,0,9,10.17,10.45,10.45,0,0,1,4.26,3.75l2.64,4.22a7,7,0,0,0,8.48,2.8l6.66-2.63a7,7,0,0,0,4.28-7.84l-1-5.06a9.82,9.82,0,0,1,.53-5.33A18.5,18.5,0,0,0,296.32,113.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.82,156.32a3.13,3.13,0,0,1-1.24-.26,3.06,3.06,0,0,1-1.66-1.71,3.11,3.11,0,0,1,1.75-4l8.83-3.49a3.1,3.1,0,0,1,4,1.75,3.07,3.07,0,0,1,0,2.38,3.13,3.13,0,0,1-1.71,1.66L288,156.1A3,3,0,0,1,286.82,156.32Zm8.82-8.71a2,2,0,0,0-.77.15L286,151.25a2.1,2.1,0,0,0-.07,3.89,2.07,2.07,0,0,0,1.62,0l8.83-3.48a2.09,2.09,0,0,0,1.15-1.13,2,2,0,0,0,0-1.61,2.13,2.13,0,0,0-2-1.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.32,161.7a2.09,2.09,0,0,1-.78-.16,2,2,0,0,1-1-1.07l-.15-.39a1.93,1.93,0,0,1,1.09-2.51l5.51-2.18a2,2,0,0,1,2.52,1.09l.15.39a1.95,1.95,0,0,1-1.09,2.51L292,161.56A1.9,1.9,0,0,1,291.32,161.7Zm5.35-5.45a1,1,0,0,0-.34.07l-5.51,2.18a.93.93,0,0,0-.53,1.21l.15.39a.94.94,0,0,0,1.22.53l5.51-2.18a.94.94,0,0,0,.52-.5.92.92,0,0,0,0-.71l-.15-.39A1,1,0,0,0,296.67,156.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.91,131.46a3.75,3.75,0,1,1,3.48-5.13l1.38,3.49-3.49,1.37A3.67,3.67,0,0,1,274.91,131.46Zm0-6.5a2.75,2.75,0,1,0,1,5.3l2.56-1-1-2.55A2.74,2.74,0,0,0,274.9,125Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.97 148.24 278.48 129.25 285.37 126.53 292.86 145.52 291.93 145.89 284.8 127.83 279.77 129.82 286.9 147.87 285.97 148.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.8,127.83l-1.37-3.49a3.75,3.75,0,1,1,4.86,2.11Zm2.11-7.62a2.79,2.79,0,0,0-1,.2,2.74,2.74,0,0,0-1.54,3.57l1,2.55,2.55-1a2.75,2.75,0,0,0-1-5.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.33,175.49a68.37,68.37,0,0,1-11.21-.91l.17-1a67.4,67.4,0,0,0,11,.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,185.85l.53-1.08a19.55,19.55,0,0,0,1.05-13.07,62.46,62.46,0,0,1-12,3l-.15-1a61.45,61.45,0,0,0,12.28-3.16l.5-.18.15.5a21,21,0,0,1-.47,13.21c12.29-4.89,25.12-22.25,25.12-42.93,0-18.36-21.41-33.3-47.73-33.3s-47.72,14.94-47.72,33.3c0,13.35,11.37,25.38,29,30.64l-.29,1c-18-5.39-29.68-17.79-29.68-31.6,0-18.91,21.86-34.3,48.72-34.3s48.73,15.39,48.73,34.3c0,21.74-14,39.91-26.9,44.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.33,
    y: 118.1,
    width: 42.64,
    height: 28.96,
    rx: 4.4,
    transform: "translate(-18.1 60.9) rotate(-10.13)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.76 131.49 328.96 127.23 331.17 139.57 340.76 131.49",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-139"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.11,
    y: 296.67,
    width: 91.34,
    height: 10.91,
    rx: 3.19,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.3 410.24 216.83 410.24 213.92 307.58 210.41 307.58 214.3 410.24",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.3 410.24 216.83 410.24 213.92 307.58 210.41 307.58 214.3 410.24",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.97 410.24 188.44 410.24 191.36 307.58 194.86 307.58 190.97 410.24",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.97 410.24 188.44 410.24 191.36 307.58 194.86 307.58 190.97 410.24",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.59 410.24 157.13 410.24 154.21 307.58 150.7 307.58 154.59 410.24",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.59 410.24 157.13 410.24 154.21 307.58 150.7 307.58 154.59 410.24",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.27 410.24 128.73 410.24 131.65 307.58 135.15 307.58 131.27 410.24",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.27 410.24 128.73 410.24 131.65 307.58 135.15 307.58 131.27 410.24",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.31 384.15 250.33 381.1 242.91 360.04 233.9 363.09 241.31 384.15",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.66,377.62,239.78,382a.6.6,0,0,0-.33.85l3.75,7.62a1.93,1.93,0,0,0,2.39.81c3.41-1.57,4.94-2.48,9.29-4.39,2.68-1.17,8.07-3.26,11.41-5.41s.72-5.25-.92-4.63c-3.89,1.48-10.36,1.42-13.9.66A3,3,0,0,0,249.66,377.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.9 363.1 242.92 360.04 247.15 372.09 237.98 374.71 233.9 363.1",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.42,268.19s45,8.12,48.63,22.9c7.13,29.22,23.21,74.92,23.21,74.92l-17.12,5s-24.48-52.41-27.56-70.05c-25.25,0-56,2-60-8.68-3.51-9.48-2.26-24.05-2.26-24.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.2 374 251.2 367.4 249.49 358.37 227.68 366.05 231.2 374",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.11 387.35 212.07 388.11 206.22 363.53 196.93 365.63 202.11 387.35",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.82,385.71l-10.73-1.19a.61.61,0,0,0-.72.58l-.56,8.48a2,2,0,0,0,1.67,1.89c3.73.35,5.52.32,10.24.84,2.9.32,8.62,1.21,12.59,1s3.25-4.2,1.51-4.47c-4.11-.67-9.67-3.95-12.36-6.38A2.93,2.93,0,0,0,211.82,385.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.93 365.64 206.22 363.54 209.17 375.96 199.78 377.61 196.93 365.64",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,268.19s54.71,8.19,52.2,28.9c-3.61,29.86,5.66,73.05,5.66,73.05l-17.55,3.14s-12.9-53.68-13-71.59c-17.8,0-48.9,1.27-52.88-9.45-3.51-9.48-2.26-24.05-2.26-24.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.1 376.2 213.69 371.72 212.93 362.57 190.43 367.92 193.1 376.2",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.86,210.64c1.46,5.72,2.89,11.49,4.29,17.24s2.77,11.51,4.22,17.19l1.09,4.23.56,2.08.29,1,0,.13,0,.06s0-.09-.05-.13a3.66,3.66,0,0,0-.28-.59l-.15-.23-.11-.15-.2-.22c-.21-.2-.24-.17-.19-.12a1.89,1.89,0,0,0,.36.29,10.88,10.88,0,0,0,1.38.79c1.08.53,2.34,1,3.63,1.52,5.2,1.93,10.94,3.57,16.52,5.34l-.88,6.38a90.82,90.82,0,0,1-9.2-.36,81.94,81.94,0,0,1-9.27-1.3,40.56,40.56,0,0,1-4.86-1.26,21.9,21.9,0,0,1-2.69-1.06,12.5,12.5,0,0,1-1.55-.86,10.26,10.26,0,0,1-1.89-1.55c-.18-.2-.35-.39-.55-.65l-.28-.38-.28-.47a7.55,7.55,0,0,1-.53-1.1l-.16-.46-.39-1.1-.75-2.18c-.49-1.45-1-2.9-1.41-4.34-1.81-5.78-3.46-11.53-5-17.32s-3-11.57-4.34-17.43Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.8,203.72c5.49-6.12,14.19-1.84,17.86,11.86,1.78,6.66,1.22,10.14,1.22,10.14l-18.94,5.84C164.87,222.56,161.33,212.06,168.8,203.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.8,203.72c5.49-6.12,14.19-1.84,17.86,11.86,1.78,6.66,1.22,10.14,1.22,10.14l-18.94,5.84C164.87,222.56,161.33,212.06,168.8,203.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M224.15,256.5l-1.7-.52a7.93,7.93,0,0,0-3.18-.29l-3.65.43a8.59,8.59,0,0,0-5.57,4.27l-1.24,2.42c.62,4.46,9.66,3,9.66,3H227l-.28-6.06A3.61,3.61,0,0,0,224.15,256.5Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,246.74A9,9,0,0,1,228,251.2c-.91,1.33-1.85,2.65-2.8,4-1.91,2.61-3.86,5.18-6,7.63a.58.58,0,0,1-.95-.65c1.48-2.9,3.15-5.66,4.86-8.4q1.29-2.05,2.64-4.07a9.11,9.11,0,0,1,3.37-3.56.66.66,0,0,1,1,.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.07,197.79l-10.67-3-13.73-.64a9.51,9.51,0,0,0-9.49,6.56c-2.62,8-5,19.52-6.78,29.49a231.8,231.8,0,0,0-3.21,38h51.23c1.05-28.45,4.4-42.35,6.38-52.42a13.72,13.72,0,0,0-7.55-15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.76,199.79c1.3,3.34,6.33,10.48,12.18,13.27,3.25-2.35,3.95-7.48,4.44-9.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.38,203.18a5.2,5.2,0,0,0-.44-3.94c-.83-1.3-.62-2.79.21-4.32a14.91,14.91,0,0,1,2.45-3.33l-6.71-7.85-5.47-6.34c-.47,5.93-.93,13.28-5.61,17.88-1.65,1.63-2,2.12-1.05,4.51,1.3,3.34,6,8,11.8,10.79A11.37,11.37,0,0,0,172.38,203.18Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.54,190.24l-3.79-6.15c-.07.16-.16.33-.25.51a14.39,14.39,0,0,0-.82,2.36c-.69,2.73,1.63,6.63,4.17,8.49.11-.17.2-.35.3-.53a18.68,18.68,0,0,1,2.29-3.23,1,1,0,0,1,.16-.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.78,175.54c.88,5.67,9-8.92,4.46-12.12C184.7,159.5,184.12,164.75,185.78,175.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,168.14c-.52,9.21-1.31,14.56,2.92,19.88,6.36,8,18.57,5.36,21.94-3.45,3-7.94,3.37-21.66-5.48-26.52S163.19,158.94,162.67,168.14Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.82,162.61s5.89,5.78,10.09,3.39,5.05-8.58,0-14c-2.43-2.61-6.11-5.16-13.33-5a5.56,5.56,0,0,0,2,1.25s-9.16-1.53-15.54,1.1a5.86,5.86,0,0,0,2,1.86c-6.21-.47-12.25,2-8,7.83-5.63.55-6.89,7.75-3.89,12.5s3.53,8.31,7.54,10.47c0-6.47,1.49-8,1.49-8,2.89-1.23,6.22-7.39,5.55-10.5C174.91,166,181.5,166.82,180.82,162.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52,158.83a12.7,12.7,0,0,1-4.39-5.55c-.72,3.22,2.61,6.89,2.61,6.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.07,173.17a8.76,8.76,0,0,0,2.33,5.67c1.91,2,4.51.3,5-2.27.4-2.31-.58-5.84-3-6.88S158,170.59,158.07,173.17Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.75,172.89c-.15.76.12,1.47.61,1.59s1-.4,1.17-1.16-.12-1.47-.61-1.59S177.9,172.14,177.75,172.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.25,174.92c-.16.76.12,1.46.61,1.58s1-.4,1.17-1.16-.13-1.47-.62-1.58S186.4,174.16,186.25,174.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.42,174.86a24.57,24.57,0,0,0,1.52,6.36c-1.4.71-3.16-.36-3.16-.36Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.21,185.11a6.66,6.66,0,0,1-4.29-3,.23.23,0,1,1,.4-.22,6.37,6.37,0,0,0,4.82,2.88.21.21,0,0,1,.2.24.22.22,0,0,1-.24.21A7.55,7.55,0,0,1,180.21,185.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.63,169.83a.46.46,0,0,1-.18-.13.46.46,0,0,1,.06-.64,4.35,4.35,0,0,1,4-.9.45.45,0,1,1-.29.86,3.48,3.48,0,0,0-3.13.74A.45.45,0,0,1,176.63,169.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.3,170a.55.55,0,0,1,0-.22.47.47,0,0,1,.56-.32,4.37,4.37,0,0,1,3,2.78.45.45,0,0,1-.31.56.45.45,0,0,1-.56-.31,3.43,3.43,0,0,0-2.39-2.15A.48.48,0,0,1,187.3,170Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.81,207.88c-1.92,5.48-3.84,11.19-5.55,16.79-.87,2.8-1.66,5.61-2.37,8.38a71.5,71.5,0,0,0-1.6,8.08c0,.3-.08.63-.09.92l0,.44c0,.14,0,.35,0,.28s-.08.06,0,.27a5.71,5.71,0,0,0,1.21,2.06,30.79,30.79,0,0,0,5.8,5,129.85,129.85,0,0,0,15.05,8.74L158.12,265a79.29,79.29,0,0,1-9.15-2.58,73.35,73.35,0,0,1-8.92-3.73,36.93,36.93,0,0,1-8.7-5.91,16.88,16.88,0,0,1-3.92-5.41,11.88,11.88,0,0,1-1-4.16c0-.45,0-.61,0-.85v-.7c0-.47,0-.9,0-1.35a67.72,67.72,0,0,1,1.25-9.91c.6-3.16,1.35-6.22,2.16-9.26a178.07,178.07,0,0,1,5.81-17.82Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,194.09c9.78-.09,11.63,7.52,6.31,19.58A68.82,68.82,0,0,1,143.89,226l-16.17-8.59C129.88,207.78,133.83,194.19,145,194.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,257.88l-3.58-2a3.14,3.14,0,0,0-1.92-.36l-4.3.6c-2.89.3-5,2.51-6.57,4.43l-1.83,2.24c-.09,4.52,11.33,3.46,11.33,3.46l10-.13-.31-3.94A5.44,5.44,0,0,0,172,257.88Z",
    style: {
      fill: "#ffc3bd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-139"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.65,
    y: 263.89,
    width: 270.69,
    height: 12.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.65,
    y: 263.89,
    width: 87.8,
    height: 12.67,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.76,
    y: 276.56,
    width: 4.14,
    height: 139.68,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.76,
    y: 276.56,
    width: 4.14,
    height: 139.68,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.21,
    y: 276.56,
    width: 4.14,
    height: 139.68,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.21,
    y: 276.56,
    width: 4.14,
    height: 139.68,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.65,
    y: 276.56,
    width: 4.14,
    height: 139.68,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.65,
    y: 276.56,
    width: 4.14,
    height: 139.68,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.1,
    y: 276.56,
    width: 4.14,
    height: 139.68,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.1,
    y: 276.56,
    width: 4.14,
    height: 139.68,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,207.89H282a5.6,5.6,0,0,0-5.3,4.55l-7.72,46.89a3.78,3.78,0,0,0,3.8,4.56h74a5.6,5.6,0,0,0,5.31-4.56l7.72-46.89A3.77,3.77,0,0,0,356,207.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.51,
    y: 260.83,
    width: 71.33,
    height: 3.06,
    rx: 0.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,207.89H283.62a5.6,5.6,0,0,0-5.3,4.55l-7.72,46.89a3.77,3.77,0,0,0,3.8,4.56h72.33a5.6,5.6,0,0,0,5.31-4.56l7.72-46.89A3.77,3.77,0,0,0,356,207.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.46,260.83s23.83,3.55,35.33-1.14c5.38,2.59,24.54,3.87,31.21,1.14-2.06,2.39-6.9,3.06-6.9,3.06H173.83C169,263.89,165.31,261.78,164.46,260.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.46,260.83s23.83,3.55,35.33-1.14c5.38,2.59,24.54,3.87,31.21,1.14-2.06,2.39-6.9,3.06-6.9,3.06H173.83C169,263.89,165.31,261.78,164.46,260.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtiva);
export default __webpack_public_path__ + "static/media/protiva.6576e842021692d37979095128622b1d.svg";
export { ForwardRef as ReactComponent };